module.exports = __webpack_public_path__ + "img/freescout_inactive.7eaf8e15.png";